/** 全站页脚 / 版权信息（与路由、导航保持一致） */
export const SITE_META = {
  siteName: 'CoolPeople',
  domain: 'CoolPeople.com.cn',
  company: '广州丰捷软件技术有限公司',
  icp: '粤ICP备15110461号-5',
  icpUrl: 'https://beian.miit.gov.cn/',
  tagline: '连接有趣的人和分享经验的地方'
}

export function getCopyrightYear() {
  return new Date().getFullYear()
}

/** 桌面端页脚分栏 */
export const FOOTER_COLUMNS = [
  {
    id: 'product',
    title: '产品',
    links: [
      { to: '/', label: '首页' },
      { to: '/blogs', label: '编辑推荐' },
      { to: '/exames', label: '心智测试' },
      { to: '/knowledge/courses', label: '知识课程' },
      { to: '/referral/bind-coupon', label: '绑定礼券' },
      { to: '/download-app', label: '下载 APP' }
    ]
  },
  {
    id: 'social',
    title: '认识人',
    links: [
      { to: '/moment', label: '动态' },
      { to: '/search', label: '找人' },
      { to: '/people', label: '系统推荐' },
      { to: '/like', label: '喜欢' },
      { to: '/visite', label: '谁看过我' }
    ]
  },
  {
    id: 'support',
    title: '支持与关于',
    links: [
      { to: '/about', label: '关于 CoolPeople' },
      { to: '/help', label: '帮助中心' },
      { to: '/feedback', label: '意见反馈' },
      { to: '/contact', label: '联系我们' },
      { to: '/team', label: '团队介绍' }
    ]
  }
]

/** 移动端：「其他」下拉菜单（原页脚链接，不含主导航已展示的「朋友」项） */
export const MOBILE_OTHER_LINKS = [
  { to: '/download-app', label: '下载 APP' },
  { to: '/about', label: '关于 CoolPeople' },
  { to: '/help', label: '帮助中心' },
  { to: '/feedback', label: '意见反馈' },
  { to: '/contact', label: '联系我们' },
  { to: '/team', label: '团队介绍' }
]
  // { to: '/', label: '首页' },
  // { to: '/blog', label: '编辑推荐' },
  // { to: '/exames', label: '心智测试' },
  // { to: '/knowledge/courses', label: '知识课程' },

/** @deprecated 使用 MOBILE_OTHER_LINKS */
export const MOBILE_FOOTER_LINKS = MOBILE_OTHER_LINKS

export const MOBILE_FRIEND_LINKS = [
  { to: '/moment', label: '动态' },
  { to: '/search', label: '找人' },
  { to: '/people', label: '系统推荐' },
  { to: '/like', label: '喜欢' },
  { to: '/visite', label: '谁看过我' }
]
